import { post } from '../index';

// Platform admin: undo mainAdminSuspendCompany - logins work again and
// Stripe collection resumes on the subscriptions we paused.
// Response: { company, billing: { resumed: [subIds], customerId, error } }
export const mainAdminResumeCompany = (companyId, body = {}) => {
  return post(`/admin-panel/companies/${companyId}/resume`, body);
};
